import React from 'react';
import { Alert } from 'reactstrap';
import ServiceStatus from './ServiceStatus';

const alertStyle = {
  marginBottom: 4,
  padding: 2,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

const Host = ({ color, services, name }) => (
  <Alert outline="true" style={alertStyle} color={color}>
    {services && <ServiceStatus services={services} />}
    <small>{name}</small>
  </Alert>
);

export default Host;
